<template>
  <div id="contact-update" class="row" v-if="detail.id !== ''">
    <form id="update-contact-form" class="small-12 medium-5 columns" @submit.prevent="submitForm">
      <label>
        {{ 'Name'|t }}
        <input type="text" v-model="name" :placeholder="'Name'|t" />
      </label>

      <label>
        {{ 'Organization'|t }}
        <input type="text" v-model="org" :placeholder="'Organization'|t" />
      </label>

      <label>
        {{ 'Street'|t }}
        <input type="text" v-model="street" :placeholder="'Street'|t" />
      </label>

      <label>
        {{ 'Postal code'|t }}
        <input type="text" v-model="postcode" placeholder="1-16" pattern=".{1,16}" />
      </label>

      <label>
        {{ 'City'|t }}
        <input type="text" v-model="city" :placeholder="'City'|t" />
      </label>

      <label>
        {{ 'Country'|t }}
        <input type="text" v-model="country" placeholder="LL" pattern=".{2}" />
      </label>

      <label>
        {{ 'State'|t }}
        <input type="text" v-model="state" placeholder="LL" pattern=".{2}" />
      </label>

      <label>
        {{ 'E-mail address'|t }}
        <input type="email" v-model="email" :placeholder="'E-mail address'|t" />
      </label>

      <label>
        {{ 'Telephone'|t }}
        <input type="tel" v-model="telephone" placeholder="+NNN.NNNNNNNNNNNNNN" pattern="\+\d{1,3}\.\d{1,14}" />
      </label>

      <label>
        {{ 'Fax'|t }}
        <input type="tel" v-model="fax" placeholder="+NNN.NNNNNNNNNNNNNN" pattern="\+\d{1,3}\.\d{1,14}" />
      </label>

      <label>
        {{ 'Authentication password'|t }}
        <input type="text" v-model="authinfo" />
      </label>

      <label>
        {{ 'IDNum'|t }}
        <input type="text" v-model="idnum" placeholder="5-20" pattern=".{0}|.{5,20}" />
      </label>

      <label>
        {{ 'VAT'|t }}
        <input type="text" v-model="vat" placeholder="5-20" pattern=".{0}|.{5,20}" />
      </label>

      <label>
        {{ 'Date of birth'|t }}
        <input type="date" v-model="birthdate" />
      </label>

      <fieldset class="fieldset">
        <legend>{{ 'Disclose contact information'|t }}</legend>
        <label v-for="info in getDiscloseList()">
          <input type="checkbox" v-model="disclose" :value="info.field" />
          {{ info.label|t }}
        </label>
      </fieldset>

      <fieldset class="fieldset">
        <legend>{{ 'Contact statuses'|t }}</legend>
        <label v-for="s in getStatusList()">
          <input type="checkbox" v-model="status" :value="s" />
          {{ s }}
        </label>
      </fieldset>

      <input type="submit" name="submit" :value="'Submit'|t" class="medium expanded success button" />
    </form>
  </div>
</template>

<script>
  import api from '@/api';
  import router from '@/routes';

  export default {
    name: 'CreateForm',
    props: {
      id: {
        type: String,
        required: true,
      },
    },
    created() {
      let self = this;
      let statuses = this.getStatusList();
      api.viewContact(
        {contact_id: this.id},
        data => {
          self.detail = data;
          self.name = data.name;
          self.org = data.org;
          self.street = data.street;
          self.postcode = data.postcode;
          self.city = data.city;
          self.country = data.country;
          self.state = data.state;
          self.email = data.email;
          self.telephone = data.phone;
          self.fax = data.fax;
          self.authinfo = data.authinfo;
          self.idnum = data.idnum;
          self.vat = data.vat;
          self.disclose = data.disclose.split(',');
          self.status = data.status.filter(word => statuses.indexOf(word) > -1);

          if (data.birthdate !== "") {
            self.birthdate = data.birthdate.split('T')[0];
          }
        }
      )
    },
    data() {
      return {
        detail: {
          id: ""
        },
        name: null,
        org: null,
        street: null,
        postcode: null,
        city: null,
        country: null,
        state: null,
        email: null,
        telephone: null,
        fax: null,
        authinfo: null,
        idnum: null,
        vat: null,
        birthdate: null,
        disclose: [],
        status: []
      }
    },
    methods: {
      submitForm() {
        let request = JSON.parse(JSON.stringify(this._data));
        request.contact_id = this.id;

        delete request.detail;
        delete request.disclose;
        delete request.status;

        for (let key in request) {
          if (request[key] === "" || request[key] === null) {
            delete request[key];
          }
        }

        let disclosable = this.getDiscloseList();
        for (let i in disclosable) {
          let name = disclosable[i].field;
          request['disclose_' + name] = this.disclose.indexOf(name) > -1;
        }

        let status_add = [];
        let status_remove = [];
        let statuses = this.getStatusList();
        for (let i in statuses) {
          if (this.status.indexOf(statuses[i]) === -1 && this.detail.status.indexOf(statuses[i]) > -1) {
            status_remove.push(statuses[i]);
          }
          if (this.status.indexOf(statuses[i]) > -1 && this.detail.status.indexOf(statuses[i]) === -1) {
            status_add.push(statuses[i]);
          }
        }
        if (status_add.length > 0) {
          request.status_add = status_add;
        }
        if (status_remove.length > 0) {
          request.status_remove = status_remove;
        }

        api.updateContact(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Contact %s has been updated.",
              args: [data.contact_id]
            }, {root: true});
            router.push({name: 'contact.collection'});
          }
        );
      },
      getDiscloseList() {
        return [
          {field: 'name', label: 'Name'},
          {field: 'org', label: 'Organization'},
          {field: 'addr', label: 'Address'},
          {field: 'voice', label: 'Telephone'},
          {field: 'fax', label: 'Fax'},
          {field: 'email', label: 'E-mail'},
        ];
      },
      getStatusList() {
        return [
          'clientDeleteProhibited',
          'clientTransferProhibited',
          'clientUpdateProhibited'
        ];
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/contact/Update.vue